<template>
  <div class="home-page">
    <div class="home-page__bg">
      <div class="home-page__bg-image"></div>
      <div class="home-page__bg-overlay"></div>
    </div>

    <div class="home-page__content">
      <div class="home-page__header">
        <h2 class="home-page__title">
          <span class="home-page__title-line">原创不设限，歌声自有天</span>
          <span class="home-page__title-line">新作原创，声声动心</span>
        </h2>
        <p class="home-page__subtitle">收纳世间原创旋律，珍藏人间诗意歌声</p>
      </div>

      <div class="home-page__filters">
        <div class="home-page__filters-inner">
          <button
            v-for="tab in categoryTabs"
            :key="tab"
            class="home-page__filter-btn"
            :class="{ 'home-page__filter-btn--active': activeCategory === tab }"
            @click="handleCategoryClick(tab)"
          >
            {{ tab }}
          </button>
        </div>
      </div>

      <div class="home-page__channels">
        <div class="home-page__channels-grid">
          <router-link
            v-for="channel in channels"
            :key="channel.id"
            :to="{ name: 'xiangqing', params: { id: channel.id } }"
            class="home-page__channel-card"
          >
            <div class="home-page__channel-image-wrap">
              <img :src="channel.image" :alt="channel.music_name" class="home-page__channel-image" />
              <div v-if="channel.isnomf == 1" class="home-page__channel-vip">VIP</div>
              <div class="home-page__channel-overlay">
                <button class="home-page__channel-favorite">
                  <svg class="home-page__heart-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                  </svg>
                </button>
                <button class="home-page__channel-play">
                  <svg class="home-page__play-icon" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="6 4 20 12 6 20 6 4"></polygon>
                  </svg>
                </button>
                <div class="home-page__channel-info">
                  <div class="home-page__channel-name">{{ channel.music_name }}</div>
                  <div class="home-page__channel-now-playing">{{ channel.singer }}</div>
                  <div class="home-page__channel-track">时长：{{ channel.shichang }} </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>

        <div class="home-page__pagination" v-if="total > pageSize">
          <button 
            class="home-page__pagination-btn" 
            :disabled="currentPage === 1"
            @click="prevPage"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
          <span class="home-page__pagination-info">{{ currentPage }} / {{ Math.ceil(total / pageSize) }}</span>
          <button 
            class="home-page__pagination-btn" 
            :disabled="currentPage >= Math.ceil(total / pageSize)"
            @click="nextPage"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Shouye',
  data() {
    return {
      activeCategory: '全部',
      categoryTabs: [
        '全部', '舒缓慢板', '治愈暖心', '轻快甜系', '伤感慢歌',
        '空灵氛围感', '活力轻快', '慵懒松弛', '安眠助眠', '温柔抒情',
        '辽阔治愈'
      ],
      channels: [],
      allChannels: [],
      isLoading: false,
      currentPage: 1,
      pageSize: 12,
      total: 0
    }
  },
  mounted() {
    this.loadChannels('全部');
  },
  methods: {
    handleCategoryClick(tab) {
      this.activeCategory = tab;
      this.currentPage = 1;
      this.loadChannels(tab);
    },
    loadChannels(name) {
      this.isLoading = true;
      axios.get('https://xinyinyue.xiangyouhulian.cn/api/index/index', {
        params: {
          name: name
        }
      })
      .then(response => {
        console.log('获取频道数据成功:', response);
        
        const data = response.data;
        this.allChannels = data.data || data;
        this.total = this.allChannels.length;
        this.updateDisplayChannels();
        
      })
      .catch(error => {
        console.error('获取频道数据失败:', error);
        this.allChannels = [];
        this.channels = [];
        this.total = 0;
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    updateDisplayChannels() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.channels = this.allChannels.slice(start, end);
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updateDisplayChannels();
      }
    },
    nextPage() {
      if (this.currentPage < Math.ceil(this.total / this.pageSize)) {
        this.currentPage++;
        this.updateDisplayChannels();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.home-page {
  width: 100%;
  min-height: calc(100vh - 80px);
  position: relative;
  overflow: visible;
  font-family: Arial, Helvetica, sans-serif;
  background-color: #9a1f13;
  background-image: url('../../assets/hoem.jpg');
  background-size: 100% auto;
  background-position: right top;
  background-repeat: no-repeat;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  &__content {
    position: relative;
    z-index: 1;
    padding: 60px 50px 80px;
    max-width: 1400px;
    margin: 0 auto;
  }

  &__header {
    margin-bottom: 35px;
  }

  &__title {
    font-size: 42px;
    font-weight: 300;
    color: #ffffff;
    line-height: 1.15;
    margin: 0 0 12px 0;
  }

  &__title-line {
    display: block;
  }

  &__subtitle {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.85);
    margin: 0;
    font-weight: 300;
  }

  &__filters {
    margin-bottom: 25px;
  }

  &__filters-inner {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    background-color: rgba(0, 0, 0, 0.15);
    padding: 10px 14px;
    border-radius: 4px;
  }

  &__filter-label {
    font-size: 11px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.7);
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-right: 8px;
  }

  &__filter-btn {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
    font-weight: 600;
    padding: 6px 12px;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s;
    letter-spacing: 0.3px;
    text-transform: uppercase;

    &:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.1);
    }

    &--active {
      background-color: #ffffff;
      color: #9a1f13;

      &:hover {
        background-color: #ffffff;
        color: #9a1f13;
      }
    }
  }

  &__channels {
    width: 100%;
  }

  &__channels-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;
  }

  &__channel-card {
    position: relative;
    cursor: pointer;
    transition: transform 0.3s ease, z-index 0.3s ease;
    z-index: 1;

    &:hover {
      transform: scale(1.08);
      z-index: 10;

      .home-page__channel-overlay {
        opacity: 1;
      }
    }

    &--active {
      transform: scale(1.08);
      z-index: 10;

      .home-page__channel-overlay {
        opacity: 1;
      }
    }
  }

  &__channel-image-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 133%;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }

  &__channel-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    background-color: #8b5a5e;
  }

  &__channel-vip {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #f37021;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 3px 8px;
    z-index: 3;
  }

  &__channel-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.7) 60%, rgba(0, 0, 0, 0.9) 100%);
    display: flex;
    flex-direction: column;
    padding: 12px;
    box-sizing: border-box;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &__channel-favorite {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #9a1f13;
    border: none;
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    z-index: 2;

    &:hover {
      background-color: #b02518;
      transform: scale(1.1);
    }
  }

  &__heart-icon {
    width: 18px;
    height: 18px;
  }

  &__channel-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: #f37021;
    border: 4px solid rgba(255, 255, 255, 0.9);
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    z-index: 2;

    &:hover {
      background-color: #d95e12;
      transform: translate(-50%, -50%) scale(1.1);
    }
  }

  &__play-icon {
    width: 22px;
    height: 22px;
    margin-left: 3px;
  }

  &__channel-info {
    position: absolute;
    bottom: 12px;
    left: 12px;
    right: 12px;
    z-index: 2;
  }

  &__channel-name {
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 8px;
    line-height: 1.2;
  }

  &__channel-now-playing {
    font-size: 10px;
    font-weight: 700;
    color: #f37021;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }

  &__channel-track {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.3;
  }

  &__pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__pagination-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    svg {
      width: 18px;
      height: 18px;
    }

    &:hover:not(:disabled) {
      background-color: #b02518;
      border-color: #b02518;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  &__pagination-info {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 500;
    min-width: 60px;
    text-align: center;
  }
}

@media (max-width: 1200px) {
  .home-page {
    &__channels-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}

@media (max-width: 768px) {
  .home-page {
    &__content {
      padding: 40px 20px 60px;
    }

    &__title {
      font-size: 32px;
    }

    &__subtitle {
      font-size: 18px;
    }

    &__channels-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
